import { Component, OnInit } from '@angular/core';


import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { GfTitleService } from '../../../../services/core.title.service';

@Component({
    selector: 'admin-report-header',
    template: `<div class="row">
    <div class="col-xs-12">
        <h1 class="page-header">
            <admin-heading-dropdown 
                [currentState]="currentState"></admin-heading-dropdown>
            <span style="margin-left: .25em; margin-right: .25em;" translate>Site Reports</span>
            <admin-report-selector [reportName]="selectedReport"></admin-report-selector>
        </h1>
    </div>
</div>

<ol class="breadcrumb print-hidden" *ngIf="project">
    <li><a uiSref="home.admin" translate>Site Admin</a></li>
    <li translate>Reports</li>
    <li>{{selectedReport}}</li>
</ol>`
})
export class SiteAdminReportsHeaderComponent implements OnInit {
    project: any = null;

    protected currentState: string = '';
    protected selectedReport: string = '';

    constructor(
        private $window: Window, 
        private stateService: StateService, 
         
        private gfTranslateService: GfTranslateService,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.currentState = this.stateService.current.name;
        this.setHeader(this.currentState);
    }

    getReportTitle(name) {
        if (name == 'home.admin.reports.cron') {
            return this.gfTranslateService.translate('Cron History');
        }
        if (name == 'home.admin.reports.summary') {
            return this.gfTranslateService.translate('Summary Report');
        }
        if (name == 'home.admin.reports.audit') {
            return this.gfTranslateService.translate('Audit Log');
        }
        if (name == 'home.admin.reports.log') {
            return this.gfTranslateService.translate('System Log');
        }
    }

    setHeader = (name) => {
        this.selectedReport = this.getReportTitle(name);
        this.titleService.setTitle('Site Admin', 'Reports', this.selectedReport);
    };
}